import { render, staticRenderFns } from "./SharedHeader.vue?vue&type=template&id=c84cf4d0&scoped=true&"
import script from "./SharedHeader.vue?vue&type=script&lang=js&"
export * from "./SharedHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84cf4d0",
  null
  
)

export default component.exports